<script setup lang="ts">
import { computed } from 'vue'

import IconRedirects from '@/components/atoms/icons/IconRedirects.vue'
import { useSiteStore } from '@/stores/site'
import type { BetaPage } from '@/types/beta-dashboard'
import { formatBetaPageUrl } from '@/utils/beta-page-url'

const props = defineProps<{ page: BetaPage }>()
const siteStore = useSiteStore()
const href = computed(() => formatBetaPageUrl(siteStore.url, props.page.route))
</script>

<template>
    <a
        v-if="href"
        :href="href"
        target="_blank"
        rel="noopener noreferrer"
        class="beta-page-public-link"
        :aria-label="`Visualizar ${page.name} no site`"
        :title="`Visualizar ${page.name} no site`"
        @click.stop
    >
        <IconRedirects aria-hidden="true" />
    </a>
</template>

<style scoped>
.beta-page-public-link {
    display: grid;
    width: 28px;
    height: 32px;
    flex-shrink: 0;
    place-items: center;
    border-radius: 8px;
    color: #71839a;
}

.beta-page-public-link :deep(svg) {
    width: 18px;
    height: 18px;
    color: inherit;
}

.beta-page-public-link:hover,
.beta-page-public-link:focus-visible {
    background: color-mix(in srgb, var(--main-color) 10%, transparent);
    color: var(--main-color);
}

.beta-page-public-link:focus-visible {
    outline: 2px solid var(--main-color);
    outline-offset: 1px;
}
</style>
